import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SwUpdate} from '@angular/service-worker';
import {interval} from 'rxjs';
import {environment} from '../../../environments/environment';
import {PwaUpdateSnackbarComponent} from '../components/pwa-update-snackbar/pwa-update-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class PwaUpdateService {
  readonly TEST_INTERVAL = 15_000; //ms;
  readonly PRODUCTION_INTERVAL = 5 * 60_000; // ms

  constructor(private swUpdate: SwUpdate, private snackbar: MatSnackBar) {
    this.checkServices();
  }

  private checkServices(): void {
    if (this.swUpdate.isEnabled) {
      interval(environment.production ? this.PRODUCTION_INTERVAL : this.TEST_INTERVAL).subscribe(async () => {
        if(window.navigator.onLine) {
          await this.swUpdate.checkForUpdate();
        }
      })

      this.swUpdate.versionUpdates.subscribe((event) => {
          if (event.type === 'VERSION_READY') {
            console.log('New update ready', event);
            this.updateIsReady();
          }
        })
    }
  }

  private updateIsReady() {
    this.snackbar.openFromComponent(PwaUpdateSnackbarComponent, {
      politeness: 'polite',
      announcementMessage: 'New update ready',
      verticalPosition: 'top'
    }).afterDismissed().subscribe(result => {
      if (result.dismissedByAction) {
        document.location.reload();
      }
    });
  }
}
